module.exports = __webpack_public_path__ + "img/13.8b2f99db.jpg";